import css from 'styled-jsx/css'

import { sizes, colors, common } from '../../../theme'


export default css`
.container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 150ms ease;
}

.container :global(.icon) {
  width: 15rem;
  height: 15rem;
}

.container :global(img) {
  width: 100%;
  height: 100%;
}

.info {
  position: relative;
  display: flex;
  flex: 1;
  flex-basis: auto;
  max-width: 100%;
  align-items: center;
  flex-direction: column;
}

.arrow {
  width: 0;
  height: 0;
  border-left: 2.8rem solid transparent;
  border-right: 2.8rem solid transparent;
  border-bottom: 3rem solid ${colors.pureWhite};
  z-index: 2;
}

.block {
  background: ${colors.midnightExpress};
  display: flex;
  flex: 1;
  flex-basis: auto;
  flex-direction: column;
  max-width: 100%;
}

.title {
  ${common.t2}
  color: ${colors.pureWhite};
}

.description {
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  font-family: 'Nexa Regular', sans-serif;
  color: ${colors.pureWhite};
  font-size: 1.6rem;
  line-height: 2.6rem;
  letter-spacing: 0.03rem;
}

@media screen and (min-width: ${sizes.media.tablet.maxWidth}) {
  .container {
    transform: translateY(0) scale(1);
  }

  .container:hover {
    transform: translateY(-0.2rem) scale(1.05);
  }

  .container:hover .block {
    box-shadow: 0 5px 40px rgba(0, 0, 0, 0.05);
  }
}
`
